import React, {Suspense} from 'react';
import { Navigate, Route } from 'react-router-dom';

const GeneralInfos = React.lazy(() => import('./index'));

const BourseGeneralInfosTable = React.lazy(() => import('./bourseGeneralInfosTable'));
const FaraBourseGeneralInfosTable = React.lazy(() => import('./faraBourseGeneralInfosTable'));

const BourseGeneralInfo = React.lazy(() => import('./bourseGeneralInfo'));
const FaraBourseGeneralInfo = React.lazy(() => import('./faraBourseGeneralInfo'));

const BourseGeneralInfoDetail = React.lazy(() => import('./bourseGeneralInfoDetail'));
const FaraBourseGeneralInfoDetail = React.lazy(() => import('./faraBourseGeneralInfoDetail'));

export const useGeneralInfoRoutes = () => {

    return (
        <Route path="generalInfos" element={<Suspense fallback={<div>منتظر باشید...</div>}><GeneralInfos /></Suspense>} >
            <Route index element={<Navigate to="bourse" />} />
            
            <Route path="bourse">
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><BourseGeneralInfosTable/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><BourseGeneralInfo/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><BourseGeneralInfoDetail/></Suspense> } />
                </Route>
            </Route>
            
            <Route path="faraBourse">
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><FaraBourseGeneralInfosTable/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><FaraBourseGeneralInfo/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><FaraBourseGeneralInfoDetail/></Suspense> } />
                </Route>
            </Route>
        </Route>
    )
}